import { Box, Button, Grid, Skeleton, Typography } from "@mui/material";
// import ImageUpload from '../../step-three/ImageUpload'

import "assets/css/SweetAlert.css";
import CustomTextFiled from "components/CustomTextField";
import { ROUTES } from "constants/routes";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import imageService from "services/image.service";
import { handleBackdropConfig, handleSnackBar } from "slices/global";
import { saveListingData } from "slices/listingReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import Swal from "sweetalert2";
import { getCurrentTimestamp } from "utils/timestamp.util";
import { Label, SubTitle, Title } from "../mui.styles";
import ChangePhoneNumber from "../ChangePhoneNumber";
const ModalBg = require("assets/img/png/listEquimentSuccessAlert1.png");
const SuccessCheck = require("assets/img/png/successful_check.png");
const uploadImg = async (img: any, id: any) => {
  const uploadResp = await imageService.UploadImageToStorage(
    [img],
    `listing-images/${
      id ? `${id}` : "test"
    }/${getCurrentTimestamp()}_${img.name.replaceAll(" ", "_")}`
  );
  return uploadResp;
};

const Pricing = (props: any) => {
  const {
    currentStep,
    generalReducer,
    setCurrentStep,
    isMobileView,
    changeStepStatus,
    stepStatus,
    editId,
  } = props;

  const { userReducer }: any = useAppSelector((state) => state);
  const { submittingProfile, loadingProfile } = userReducer;
  const { setValue, control, watch, trigger, clearErrors, formState } =
    useFormContext();
  const values = watch();
  const { usage_type } = values;
  const dispatch = useAppDispatch();
  const equipmentType = values?.equipmentType;
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    setValue("price_unit", "1");
  }, [setValue]);

  const navigateNext = async (skipMobileCheck = false) => {
    const res = await trigger();
    if (!res) {
      const allSteps = Object.keys(stepStatus);
      let pendingSteps = allSteps?.filter((el) => {
        if (el == "Configurations") return false;
        if (el == "Usage Rates" && values?.usage_type == 1) return false;
        return !stepStatus[el].submitted;
      });
      if (pendingSteps?.length) {
        pendingSteps?.forEach((p: any) => changeStepStatus(p, "error", true));
        trigger(["custom_min_rental_duration", "price"]);
        dispatch(
          handleSnackBar({
            open: true,
            severity: "error",
            message: `Missing Required Fields/ Possible Errors in ${pendingSteps?.toString()} Steps`,
          })
        );
      }
      return;
    }
    // Check For MobilE number updatation
    const { mobile_number, mobile_number_verified } = userReducer?.userProfile;
    const MobileNo =
      (mobile_number && mobile_number_verified) || skipMobileCheck;
    if (res && MobileNo) {
      dispatch(handleBackdropConfig({ open: true }));
      // changeStepStatus(currentStep, "loading", true);

      const uploadedImages = values?.images?.filter(
        (img: any) => !("preview_url" in img)
      );

      const promises = uploadedImages?.map(
        async (img: any) => await uploadImg(img, values?.id)
      );
      if (promises?.length) {
        return Promise.all(promises)
          ?.then(async (res) => {
            await imageService.saveImage({
              files: res.map((r: any) => ({
                bucket: r.bucket,
                full_path: r.full_path,
                name: r.name,
                size: r.size,
                content_type: r.content_type,
                preview_url: r.preview_url,
                listing_id: Number(values?.id),
              })),
            });
            return saveData();
          })
          .catch((e: any) => {
            console.log({ e });
            dispatch(
              handleSnackBar({
                open: true,
                severity: "error",
                message: `Error while uploading Images, Please try again!`,
              })
            );
          });
      }
      return saveData();
    } else {
      return setShowDialog(true);
    }
  };

  const saveData = async () => {
    if (editId) {
      const deletedImages = values?.deletedImages;
      if (deletedImages?.length) {
        const dltPromises = deletedImages?.map(
          async (img: any) => await imageService.removeImage({ body: img })
        );
        await Promise.all(dltPromises);
      }
    }
    let payload: any = {
      basic: {
        listing_type: values?.equipmentType,
        listing_name: values?.listing_name,
        listing_description: values?.listing_description,
        price: Number(values?.price),
        price_unit: Number(values?.price_unit),
        // listing_address_id: 84,
      },

      configs: {
        usage_type: values?.usage_type,
        custom_hours: Number(values?.custom_hours ?? 0),
        custom_excess_hours_fee: Number(values?.custom_excess_hours_fee ?? 0),
        custom_min_rental_duration: Number(values?.custom_min_rental_duration),
        emv: Number(values?.emv),
      },
      is_last_step: true,
    };

    if (values?.equipmentType == 1) {
      //tractor payload

      // ----------------------Start of Basic Details---------------------------------
      payload["basic"]["manufacturer_id"] = values?.manufacturer_id;
      payload["basic"]["manufacturer_model_id"] = values?.manufacturer_model_id;
      // ----------------------Start of Features---------------------------------
      payload.features = {
        has_loader_bucker: values?.has_loader_bucker,
        has_ac: values?.has_ac,
        has_3point_lift: values?.has_3point_lift,
        has_heater: values?.has_heater,
        has_pto: values?.has_pto,
        has_4wd: values?.has_4wd,
        has_cabin: values?.has_cabin,
        has_power_steering: values?.has_power_steering,

        horse_power: Number(values?.horse_power),
        year: values?.year,
      };
    } else {
      //attachment payload

      // ----------------------Start of Basic Details---------------------------------
      payload["basic"]["attachment_id"] = values?.attachment_id;
      // ----------------------Start of Features---------------------------------
      payload.features = {
        attachment_type: values?.attachment_type,
        capacity: Number(values?.capacity),
        capacity_unit: values?.capacity_unit,
      };
    }
    dispatch(
      saveListingData({
        data: { ...payload, id: values?.id },
        navigate: () => {
          Swal.fire({
            title: `<img style="width:100%;padding:0" src="${ModalBg}"/>
            <img style="width:104px;padding:0;margin: auto; margin-top:-100px" src="${SuccessCheck}"/>`,
            html: `
           <span style="font-size: 25px;font-weight: 600;font-family: Inter">Thank you for choosing Haystackers!</span><br/>
           <span style="font-size: 14px;font-weight: 500;font-family: Inter;color: #A2A2A2;margin-top: 10px">Your listing is currently under review to uphold our high quality standards. We're excited to connect you with users seeking your valuable services.</span>
            `,
            showCloseButton: false,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: `
              Go to Home
            `,
            confirmButtonColor: "transparent",
            cancelButtonText: `
              Go to My Listing
            `,
            cancelButtonAriaLabel: "Thumbs down",
            padding: "0 0 26px 0",
          }).then((v) => {
            const { isConfirmed, isDismissed, isDenied } = v;
            if (isConfirmed) navigate("/");
            if (isDismissed || isDenied) navigate(ROUTES.LISTING);
          });
          changeStepStatus(currentStep, "loading", false);
          changeStepStatus(currentStep, "submitted", true);
        },
        type: values?.equipmentType,
      })
    );
  };

  const skeletonLoading = stepStatus[currentStep]?.loading;

  return (
    <Box sx={{ p: "10px 16px", ...(!isMobileView && { width: "95%" }) }}>
      <ChangePhoneNumber
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        cb={() => navigateNext(true)}
      />
      <Title>Pricing</Title>
      <SubTitle>
        Set competitive prices for your equipment to attract more bookings and
        maximize your business potential.
      </SubTitle>
      <br />

      <Grid container spacing={2} width={"100%"}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Label>How much do you want to charge for your equipment?</Label>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          {skeletonLoading ? (
            <Skeleton width="100%" height={40} variant="rounded" />
          ) : (
            <Controller
              control={control}
              name={"price"}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextFiled
                  inputValue={value}
                  label="Enter amount"
                  onInputChange={onChange}
                  showError={!!error}
                  errorMessage={error?.message || " "}
                  showEndDropDown={true}
                  dropDownValue={values?.price_unit}
                  dropDownOptions={[{ id: 1, name: "Per day" }]}
                  onDropDownChange={(v: any) => {
                    setValue("price_unit", v);
                  }}
                  inputProps={{ type: "number" }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Label>
            What is the minimum rental length you are willing to accept?
          </Label>
          <SubTitle>
            We recommend allowing a minimum rental length of 2 days.
          </SubTitle>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          {skeletonLoading ? (
            <Skeleton width="100%" height={40} variant="rounded" />
          ) : (
            <Controller
              control={control}
              name={"custom_min_rental_duration"}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextFiled
                  inputValue={value}
                  label="Enter Number of days"
                  onInputChange={onChange}
                  showError={!!error}
                  errorMessage={error?.message || " "}
                  showEndDropDown={false}
                  inputProps={{ type: "number" }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} mt={3}>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              mt: 1,
              lineHeight: "26px",
            }}
          >
            {skeletonLoading ? (
              <Skeleton width={120} height={25} variant="text" />
            ) : (
              `Cancellation policy:`
            )}
          </Typography>

          <ul
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              marginLeft: -22,
              ...(skeletonLoading && { listStyleType: "none" }),
            }}
          >
            <li
              style={{ fontSize: "16px", fontWeight: 400, lineHeight: "24px" }}
            >
              {skeletonLoading ? (
                <Skeleton width="85%" height={25} variant="text" />
              ) : (
                ` Renter will be given Full Refund If Cancelled by Renter prior to
              48 hours before Dispatch/Delivery.`
              )}
            </li>
            <li
              style={{ fontSize: "16px", fontWeight: 400, lineHeight: "24px" }}
            >
              {skeletonLoading ? (
                <Skeleton width="85%" height={25} variant="text" />
              ) : (
                `Renter will be given 75% Refund If Cancelled by Renter less than
              48 hours before Dispatch/Delivery. Dispatch/Delivery.`
              )}
            </li>
            <li
              style={{ fontSize: "16px", fontWeight: 400, lineHeight: "24px" }}
            >
              {skeletonLoading ? (
                <Skeleton width="85%" height={25} variant="text" />
              ) : (
                `Renter will be given Full Refund If Cancelled by Owner any time
              before Dispatch/Delivery.`
              )}
            </li>
          </ul>
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="end" mt={3}>
        {skeletonLoading ? (
          <Skeleton sx={{ mr: 1 }} width={160} height={40} variant="rounded" />
        ) : (
          <Button
            sx={{
              mr: 1.5,

              backgroundColor: "transparent",
              color: "primary.main",
              border: "1px solid #dfdfdf",
            }}
            variant="contained"
            type="submit"
            onClick={() => setCurrentStep("Usage Rates")}
          >
            Back
          </Button>
        )}
        {skeletonLoading ? (
          <Skeleton width={160} height={40} variant="rounded" />
        ) : (
          <Button
            variant="contained"
            onClick={() => navigateNext(false)}
            disabled={submittingProfile || loadingProfile}
            // endIcon={
            //   listingReducer.submittingListingData ? (
            //     <CircularProgress size={15} />
            //   ) : null
            // }
          >
            Publish
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default Pricing;
